import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useDeleteTag = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/tag/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['viewTags'] });
    },
  });
};